import { useFocusEffect } from 'expo-router'
import { useCallback, useState } from 'react'

const useBottomSheetKey = (): number => {
    const [key, setKey] = useState(Date.now())

    useFocusEffect(
        useCallback(() => {
            return () => setKey(Date.now())
        }, [])
    )

    return key
}

export default useBottomSheetKey
